import Box from '@/common/components/Box'
import { RewardTicketData } from '@/common/types/rewardTickets.type'
import RewardTicket from './RewardTicket'
import { ModalMessageSimple } from '@/common/components/ModalMessageSimple'
import { useEffect, useRef, useState } from 'react'
import Skeleton from '@/common/components/Skeleton'

interface RewardTicketsProps {
  raffleId?: string
  rewardTickets?: RewardTicketData[]
  hasSomeRewardTicketWithWinPosition?: boolean
  isPending?: boolean
  hasNextPage?: boolean
  isFetchingNextPage?: boolean
  fetchNextPage?: () => void
}

export default function RewardTickets({
  rewardTickets,
  raffleId,
  hasSomeRewardTicketWithWinPosition,
  isPending,
  hasNextPage,
  isFetchingNextPage,
  fetchNextPage
}: RewardTicketsProps) {
  const scrollContainerRef = useRef<HTMLDivElement>(null)
  const [messages, setMessages] = useState<string[] | boolean>(false)
  const [isError, setIsError] = useState<boolean>(false)
  
  const firstPendingTicket = rewardTickets?.find((ticket) => ticket.status !== 'accepted' && ticket.status !== 'rejected')

  useEffect(() => {
    const scrollContainer = scrollContainerRef.current
    if (!scrollContainer || !fetchNextPage) return

    const handleScroll = () => {
      const { scrollTop, scrollHeight, clientHeight } = scrollContainer
      
      if (scrollHeight - scrollTop <= clientHeight + 50) {
        if (hasNextPage && !isFetchingNextPage && !isPending) {
          fetchNextPage()
        }
      }
    }

    scrollContainer.addEventListener('scroll', handleScroll)
    return () => scrollContainer.removeEventListener('scroll', handleScroll)
  }, [hasNextPage, isFetchingNextPage, isPending, fetchNextPage])

  return (
    <Box className="flex flex-col flex-1 bg-white-100 gap-4 max-h-[600px]">
      <h3 className="text-base">
        Sorteio
      </h3>
      {hasSomeRewardTicketWithWinPosition ? (
        <div 
          ref={scrollContainerRef}
          className='flex flex-col gap-2 w-full overflow-auto'
        >
          {rewardTickets?.map((rewardTicket) => (
            <RewardTicket 
              key={rewardTicket.id} 
              rewardTicket={rewardTicket} 
              raffleId={raffleId}
              isNextToAccept={rewardTicket.id === firstPendingTicket?.id}
              setIsError={setIsError}
              setMessages={setMessages}
            />
          ))}
          {isFetchingNextPage && (
            <Skeleton className='min-w-full min-h-[200px] rounded-sm' />
          )}
        </div>
      ) : (
        <div className='flex flex-col items-center justify-center overflow-hidden'>
          <img src="/search.gif" className="w-full shrink-0 -mt-8 max-w-[400px]" />
          <div className="-mt-16 mb-16 p-8 space-y-2">
            <p className="text-sm font-bold text-center">Sorteio ainda não realizado.</p>
            <p className="text-xs text-center">Não há bilhetes disponíveis para a seleção de ganhadores. Por favor, retorne após o horário agendado para o sorteio.</p>
          </div>
        </div>
      )}

      {messages && (
        <ModalMessageSimple
          messages={messages} 
          setMessages={setMessages} 
          isError={isError} 
        />
      )}
    </Box>
  )
}
